module.exports = __webpack_public_path__ + "static/mental-health-e9c64640b6f40f225b7e3098c12c454e.png";